import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_VALUES_MODAL } from "../models/ModalInitialValue";
import type { ModalWorkOrder } from "../models/ModalWorkOrder";
import type { WorkOrderAttachment } from "../components/work-order-resources/models/WorkOrderAttachment";

const initialState: {
	modalWorkOrderSelected: ModalWorkOrder;
	searchAssetName: string;
	searchAssetId: number | string;
	showModal: boolean;
	modalType: string;
	loading: boolean;
	error: string;

	firstTime: boolean;
	workOrderAttachmentToAdd: any;
	assetAttachments: WorkOrderAttachment[];
	rowSelectedInAttachment: any;
	dataAttachmentSelected: WorkOrderAttachment | null;
	displayViewerAttachment: boolean;
	listAttachmentSelected: any[] | null;
	uploadFileDialog: boolean;
	workOrderAttachmentsList: WorkOrderAttachment[];
	// --------------------------------------------------------------------------
} = {
	modalWorkOrderSelected: INITIAL_VALUES_MODAL,
	searchAssetName: "",
	searchAssetId: 0,
	showModal: false,
	modalType: "",
	loading: false,
	error: "",

	// --------------------- WORK ORDER RESOURCES (ATTACHMENTS ONLY) -----------
	firstTime: true,
	assetAttachments: [],
	workOrderAttachmentToAdd: {},
	rowSelectedInAttachment: [],
	workOrderAttachmentsList: [],
	dataAttachmentSelected: null,
	displayViewerAttachment: false,
	listAttachmentSelected: [],
	uploadFileDialog: false,
	// --------------------------------------------------------------------------
};

export const WorkOrderModalsReducer = createSlice({
	name: "workOrderModals",
	initialState,
	reducers: {
		setModalWorkOrderSelected(state, { payload }) {
			state.modalWorkOrderSelected = payload;
		},
		setSearchAssetName(state, { payload }) {
			state.searchAssetName = payload;
		},
		setSearchAssetId(state, { payload }) {
			state.searchAssetId = payload;
		},
		setShowModal(state, { payload }) {
			state.showModal = payload;
		},
		setModalType(state, { payload }) {
			state.modalType = payload;
		},
		setLoading(state, { payload }) {
			state.loading = payload;
		},
		setError(state, { payload }) {
			state.error = payload;
		},
		resetState(state) {
			return initialState;
		},
		// Modal WorkOrder field setters
		setWorkOrderNumberOfWorkers(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderNumberOfWorkers = payload;
		},
		setWorkOrderConsumedHours(state, { payload }) {
			state.modalWorkOrderSelected.Comments = payload;
		},
		setWorkOrderCloseTimestamp(state, { payload }) {
			state.modalWorkOrderSelected.CloseTimestamp = payload;
		},
		setTemplateTitle(state, { payload }) {
			state.modalWorkOrderSelected.TemplateTitle = payload;
		},
		setWorkOrderPlannedHours(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderPlannedHours = payload;
		},
		setWorkOrderOpenedBy(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderOpenedBy = payload;
		},
		setOpenTimestamp(state, { payload }) {
			state.modalWorkOrderSelected.OpenTimestamp = payload;
		},
		setWorkOrderName(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderName = payload;
		},
		setTitle(state, { payload }) {
			state.modalWorkOrderSelected.Title = payload;
		},
		setAssetName(state, { payload }) {
			state.modalWorkOrderSelected.AssetName = payload;
		},
		setWorkOrderId(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderId = payload;
		},
		setDownHours(state, { payload }) {
			state.modalWorkOrderSelected.DownHours = payload;
		},
		setDownDayCode(state, { payload }) {
			state.modalWorkOrderSelected.DownDayCode = payload;
		},
		setAttachmentsLinked(state, { payload }) {
			state.modalWorkOrderSelected.AttachmentsLinked = payload;
		},
		setAssetId(state, { payload }) {
			state.modalWorkOrderSelected.AssetId = payload;
		},
		setCraftId(state, { payload }) {
			state.modalWorkOrderSelected.CraftId = payload;
		},
		setTypeCode(state, { payload }) {
			state.modalWorkOrderSelected.TypeCode = payload;
		},
		setWorkOrderStatusCode(state, { payload }) {
			state.modalWorkOrderSelected.WorkOrderStatusCode = payload;
		},
		setComments(state, { payload }) {
			state.modalWorkOrderSelected.Comments = payload;
		},

		// --------------------- WORK ORDER RESOURCES (ATTACHMENTS ONLY) -----------
		setFirstTime(state, { payload }) {
			state.firstTime = payload;
		},
		setAssetAttachmentsList(state, { payload }) {
			state.assetAttachments = payload;
		},
		setWorkOrderAttachmentsList(state, { payload }) {
			state.workOrderAttachmentsList = payload;
		},
		setWorkOrderAttachmentToAdd(state, { payload }) {
			state.workOrderAttachmentToAdd = payload;
		},
		setRowSelectedInAttachment(state, { payload }) {
			state.rowSelectedInAttachment = payload;
		},
		setDataAttachmentSelected(state, { payload }) {
			state.dataAttachmentSelected = payload;
		},
		setDisplayViewerAttachment(state, { payload }) {
			state.displayViewerAttachment = payload;
		},
		setListAttachmentSelected(state, { payload }) {
			state.listAttachmentSelected = payload;
		},
		setUploadFileDialog(state, { payload }) {
			state.uploadFileDialog = payload;
		},
		// --------------------------------------------------------------------------
	},
});
